import { makeStyles, mergeClasses } from "@fluentui/react-components";
import {
  AirplaneLandingFilled,
  AirplaneTakeOffFilled,
} from "@fluentui/react-icons";
import { $gray600 } from "../../cssjs/colors";
import { AirportOtp } from "../../models/airports/AirportConfig";
import { EMPTY_STATE_MESSAGE } from "../../utils/common/Constants";
import { StatusIconSelector } from "../common/icon-selectors/StatusIconSelector";
import { NoDataCard } from "../common/no-data-card/NoDataCard";

interface IAirportOTPCardProps {
  className?: string;
  otpData: AirportOtp;
  isError?: boolean;
  isMapView?: boolean;
}

const AirportOTPCard: React.FunctionComponent<IAirportOTPCardProps> = ({
  className,
  otpData,
  isError = false,
  isMapView = false,
}) => {
  const classes = useStyles();
  return (
    <div
      className={mergeClasses(classes.container, className)}
      data-testid="airport-otp-card"
    >
      <header className={classes.title}>
        {isMapView ? "OTP" : "On-time performance"}
      </header>
      {isError ? (
        <NoDataCard message={EMPTY_STATE_MESSAGE.Data} hideImage />
      ) : (
        <div className="d-flex">
          <div className="flex-1">
            <header className="fs-20 pb-sm-1">
              <StatusIconSelector status={otpData.overall.status} />
              <span>{`${Math.round(otpData.overall.value)} %`}</span>
            </header>
            <footer>Overall</footer>
          </div>
          {!isMapView ? (
            <>
              <div className="flex-1">
                <header className="fs-20 pb-sm-1">
                  <StatusIconSelector status={otpData.arrival.status} />
                  <span>{`${Math.round(otpData.arrival.value)} %`}</span>
                </header>
                <footer>
                  <AirplaneLandingFilled
                    style={{ verticalAlign: "middle", paddingRight: "4px" }}
                  />
                  Arrival
                </footer>
              </div>
              <div className="flex-1">
                <header className="fs-20 pb-sm-1">
                  <StatusIconSelector status={otpData.departure.status} />
                  <span>{`${Math.round(otpData.departure.value)} %`}</span>
                </header>
                <footer>
                  <AirplaneTakeOffFilled
                    style={{ verticalAlign: "middle", paddingRight: "4px" }}
                  />
                  Departure
                </footer>
              </div>
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default AirportOTPCard;

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: "8px",
    padding: "6px 12px",
  },
  title: { color: $gray600, fontWeight: 500 },
  icon: {
    fontSize: "18px",
    strokeWidth: "0.5px",
    verticalAlign: "bottom",
    paddingRight: "4px",
  },
  goodIcon: {
    color: "#569643",
    stroke: "#569643",
  },
  errorIcon: {
    color: "#B2271F",
    stroke: "#B2271F",
  },
  warningIcon: {
    color: "#FA6400",
    stroke: "#FA6400",
  },
});
